import MyComponentHelpers from '../MyComponent/Helpers'
import MyHelpers from './Helpers'
function MyPageLayout(props: any) {
  const MyTypeFn = MyComponentHelpers.getMyComponentTypeFn(
    MyHelpers.Types,
    props
  )
  return MyTypeFn(props)
}

export default MyPageLayout
